import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export interface IConfigStateProps {
  idiom: 'es' | 'pt';
}

const initialState: IConfigStateProps = {
  idiom: 'es',
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setIdiom: (state, action) => {
      state.idiom = action.payload === 'sobr' ? 'pt' : 'es';
    },
  },
});

//Export actions
export const { setIdiom } = configSlice.actions;

export const getIdiom = (state: RootState) => state.config.idiom;

export default configSlice.reducer;
